// import { createSlice } from "@reduxjs/toolkit";


// export const mockTestSlice = createSlice({
//   name: "mockTestSlice",
//   initialState:{title:"basicDetail"},
//   reducers: {
//     setMockData:(state,{payload})=>{
//       state=payload
//     },
//     rMockvent:()=>{}
//   },
// });

// export const {resetMock,setMockData} = mockTestSlice.actions;

// export default mockTestSlice.reducer;

import { createSlice } from "@reduxjs/toolkit";

export const mockTestSlice = createSlice({
  name: "mockTestSlice",
  initialState: { title: "basicDetail" },
  reducers: {
    setMockData: (state, { payload }) => {
      return { ...payload };  
    },
    resetMock: () => ({}) // Empty state when resetting
  },
});

export const { resetMock, setMockData } = mockTestSlice.actions;

export default mockTestSlice.reducer;
